'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

exports.getBookingData = getBookingData;
exports.getMessages = getMessages;
exports.createBooking = createBooking;
exports.sendMessage = sendMessage;
exports.activateBooking = activateBooking;
exports.updateBooking = updateBooking;
exports.confirmBooking = confirmBooking;
exports.checkCancel = checkCancel;
exports.rescheduleBooking = rescheduleBooking;
exports.respondBooking = respondBooking;
exports.setMeetingPoint = setMeetingPoint;
exports.postReview = postReview;
exports.postExtraReview = postExtraReview;
exports.replyReview = replyReview;
exports.clearLoadingData = clearLoadingData;
exports.openDetail = openDetail;
exports.openCalendar = openCalendar;
exports.clearNoti = clearNoti;
exports.pushMessage = pushMessage;
exports.setNewBookingData = setNewBookingData;
exports.setMessage = setMessage;
exports.changeStep = changeStep;
exports.submitLXCancel = submitLXCancel;
exports.loadSuggestedTrips = loadSuggestedTrips;
exports.openSuggested = openSuggested;
exports.openSwapLX = openSwapLX;
exports.openCollide = openCollide;
exports.requestSuggestedTrips = requestSuggestedTrips;
exports.requestSwapLX = requestSwapLX;
exports.setSwapRequested = setSwapRequested;
exports.submitPaymentCode = submitPaymentCode;
exports.uploadTripImage = uploadTripImage;
exports.releasePayment = releasePayment;
exports.holdPayment = holdPayment;
exports.logBookingAction = logBookingAction;
exports.logClickBookNowAndSave = logClickBookNowAndSave;
exports.openLXHotelPickup = openLXHotelPickup;
exports.closeLXHotelPickup = closeLXHotelPickup;
exports.lxAcceptHotelPickup = lxAcceptHotelPickup;
exports.openLXStreetFoodPickup = openLXStreetFoodPickup;
exports.closeLXStreetFoodPickup = closeLXStreetFoodPickup;
exports.lxStreetFoodPickup = lxStreetFoodPickup;
exports.lxOpenProposeNewDateModal = lxOpenProposeNewDateModal;
exports.lxCloseProposeNewDateModal = lxCloseProposeNewDateModal;
exports.notifyWorryFreeBooking = notifyWorryFreeBooking;

var _constant = require('./constant');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getData = function getData(client, id) {
  var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  var booking = client.get('/bookings/' + id);
  var messages = client.get('bookings/' + id + '/messages?skip=' + skip + '&limit=' + limit);
  return _promise2.default.all([booking, messages]);
};

function getBookingData(id) {
  return {
    types: [_constant.GET_BOOKING_DATA, _constant.GET_BOOKING_DATA_SUCCESS, _constant.GET_BOOKING_DATA_FAIL],
    promise: function promise(client) {
      return client.get('/bookings/' + id).then(function (result) {
        if (!result.is_booked || !result.is_confirmed) {
          return _promise2.default.resolve(result);
        }
        return client.get('/bookings/' + id + '/contact-info').then(function (contact) {
          return (0, _extends3.default)({}, result, { contact_info: contact });
        });
      });
    }
  };
}

function getMessages(id) {
  var append = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var skip = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var limit = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

  return {
    types: [_constant.GET_MESSAGES, _constant.GET_MESSAGES_SUCCESS, _constant.GET_MESSAGES_FAIL],
    promise: function promise(client) {
      return client.get('bookings/' + id + '/messages?skip=' + skip + '&limit=' + limit);
    },
    append: append
  };
}

function createBooking(data) {
  return {
    types: [_constant.CREATE_BOOKING, _constant.CREATE_BOOKING_SUCCESS, _constant.CREATE_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('/bookings', { data: data });
    },
    data: data
  };
}

function sendMessage(id, text) {
  var asSystem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return {
    types: [_constant.SEND_MESSAGE, _constant.SEND_MESSAGE_SUCCESS, _constant.SEND_MESSAGE_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/messages', { data: { text: text, asSystem: asSystem } });
    }
  };
}

function activateBooking(id) {
  return {
    types: [_constant.ACTIVATE_BOOKING, _constant.ACTIVATE_BOOKING_SUCCESS, _constant.ACTIVATE_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/activate');
    }
  };
}

function updateBooking(id, data) {
  return {
    types: [_constant.UPDATE_BOOKING, _constant.UPDATE_BOOKING_SUCCESS, _constant.UPDATE_BOOKING_FAIL],
    promise: function promise(client) {
      return client.put('bookings/' + id, { data: data }).then(function () {
        return getData(client, id);
      });
    }
  };
}

function confirmBooking(id) {
  return {
    types: [_constant.CONFIRM_BOOKING, _constant.CONFIRM_BOOKING_SUCCESS, _constant.CONFIRM_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('bookings/' + id + '/confirm').then(function () {
        return getData(client, id);
      });
    }
  };
}
function checkCancel(id) {
  return {
    types: [_constant.CHECK_CANCEL, _constant.CHECK_CANCEL_SUCCESS, _constant.CHECK_CANCEL_FAIL],
    promise: function promise(client) {
      return client.get('bookings/' + id + '/check-cancel');
    }
  };
}

function rescheduleBooking(id, days) {
  var alternateMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  return {
    types: [_constant.RESCHEDULE_BOOKING, _constant.RESCHEDULE_BOOKING_SUCCESS, _constant.RESCHEDULE_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('bookings/' + id + '/7/send', { data: { available_dates: days, alternateMessage: alternateMessage } }).then(function () {
        return getData(client, id);
      });
    },
    days: days
  };
}

function respondBooking(id, date) {
  return {
    types: [_constant.RESPOND_BOOKING, _constant.RESPOND_BOOKING_SUCCESS, _constant.RESPOND_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('bookings/' + id + '/7/respond', { data: { trip_date: date } }).then(function () {
        return getData(client, id);
      });
    },
    date: date
  };
}

function setMeetingPoint(id, text) {
  return {
    types: [_constant.SET_MEETING_POINT, _constant.SET_MEETING_POINT_SUCCESS, _constant.SET_MEETING_POINT_FAIL],
    promise: function promise(client) {
      return client.post('bookings/' + id + '/meeting-point', { data: { text: text } }).then(function () {
        return getData(client, id);
      });
    }
  };
}

function postReview(id, data) {
  return {
    types: [_constant.POST_REVIEW, _constant.POST_REVIEW_SUCCESS, _constant.POST_REVIEW_FAIL],
    promise: function promise(client) {
      return client.post('bookings/' + id + '/review', { data: data });
    }
  };
}

function postExtraReview(id, data) {
  return {
    types: [_constant.POST_EXTRA_REVIEW, _constant.POST_EXTRA_REVIEW_SUCCESS, _constant.POST_EXTRA_REVIEW_FAIL],
    promise: function promise(client) {
      return client.put('bookings/' + id + '/extra-review', { data: data });
    }
  };
}

function replyReview(id, text) {
  return {
    types: [_constant.REPLY_REVIEW, _constant.REPLY_REVIEW_SUCCESS, _constant.REPLY_REVIEW_FAIL],
    promise: function promise(client) {
      return client.post('reviews/' + id + '/reply', { data: { text: text } });
    }
  };
}

function clearLoadingData() {
  return {
    type: _constant.CLEAR_LOADING_DATA
  };
}

function openDetail() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: _constant.OPEN_DETAIL,
    active: active
  };
}

function openCalendar() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: _constant.OPEN_CALENDAR,
    active: active
  };
}

function clearNoti(id) {
  return {
    types: [_constant.CLEAR_NOTI, _constant.CLEAR_NOTI_SUCCESS, _constant.CLEAR_NOTI_FAIL],
    promise: function promise(client) {
      return client.post('/users/me/notifications/booking/' + id);
    }
  };
}

function pushMessage(msg) {
  return {
    type: _constant.PUSH_MESSAGE,
    msg: msg
  };
}
function setNewBookingData(newBooking) {
  return {
    type: _constant.SET_NEWBOOKING,
    newBooking: newBooking
  };
}
function setMessage(newMessage) {
  return {
    type: _constant.SET_MESSAGE,
    newMessage: newMessage
  };
}
function changeStep() {
  var step = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  return {
    type: _constant.CHANGE_STEP,
    step: step
  };
}
function submitLXCancel(id) {
  return {
    types: [_constant.SUBMIT_LX_CANCEL, _constant.SUBMIT_LX_CANCEL_SUCCESS, _constant.SUBMIT_LX_CANCEL_FAIL],
    promise: function promise(client) {
      return client.post('bookings/' + id + '/cancel').then(function () {
        return getData(client, id);
      });
    }
  };
}
function loadSuggestedTrips(id) {
  return {
    types: [_constant.LOAD_SUGGESTED_TRIP, _constant.LOAD_SUGGESTED_TRIP_SUCCESS, _constant.LOAD_SUGGESTED_TRIP_FAIL],
    promise: function promise(client) {
      return client.get('/bookings/' + id + '/suggestedTrips');
    }
  };
}
function openSuggested() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: _constant.OPEN_SUGGESTED,
    active: active
  };
}
function openSwapLX() {
  var active = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: _constant.OPEN_SWAP_LX,
    active: active
  };
}
function openCollide() {
  var open = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: _constant.OPEN_COLLIDE,
    open: open
  };
}

function requestSuggestedTrips(id, requestTripIds) {
  return {
    types: [_constant.REQUEST_SUGGESTED_TRIP, _constant.REQUEST_SUGGESTED_TRIP_SUCCESS, _constant.REQUEST_SUGGESTED_TRIP_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/suggestedTrips', { data: { requestTripIds: requestTripIds } });
    }
  };
}

function requestSwapLX(id) {
  return {
    types: [_constant.REQUEST_SWAP_LX, _constant.REQUEST_SWAP_LX_SUCCESS, _constant.REQUEST_SWAP_LX_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/automate-swap');
    },
    id: id
  };
}

function setSwapRequested() {
  var requested = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  return {
    type: _constant.SET_SWAP_REQUESTED,
    requested: requested
  };
}

function submitPaymentCode(id, code) {
  return {
    types: [_constant.SUBMIT_PAYMENT_CODE, _constant.SUBMIT_PAYMENT_CODE_SUCCESS, _constant.SUBMIT_PAYMENT_CODE_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/verify-payment-code', { data: { code: code } }).then(function () {
        return getData(client, id);
      });
    }
  };
}

function uploadTripImage(id, image) {
  return {
    types: [_constant.UPLOAD_TRIP_IMAGE, _constant.UPLOAD_TRIP_IMAGE_SUCCESS, _constant.UPLOAD_TRIP_IMAGE_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/upload-trip-image', { data: { image: image } }).then(function () {
        return getData(client, id);
      });
    }
  };
}

function releasePayment(id) {
  return {
    types: [_constant.RELEASE_PAYMENT, _constant.RELEASE_PAYMENT_SUCCESS, _constant.RELEASE_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/release-payment');
    }
  };
}

function holdPayment(id, topic, text) {
  return {
    types: [_constant.HOLD_PAYMENT, _constant.HOLD_PAYMENT_SUCCESS, _constant.HOLD_PAYMENT_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/hold-payment', { data: { topic: topic, text: text } }).then(function () {
        return getData(client, id);
      });
    }
  };
}

function logBookingAction(action) {
  return {
    type: _constant.LOG_BOOKING_ACTION,
    action: action
  };
}

function logClickBookNowAndSave() {
  return {
    type: _constant.LOG_CLICK_BOOK_NOW_AND_SAVE
  };
}

function openLXHotelPickup() {
  return {
    type: _constant.OPEN_LX_HOTEL_PICKUP
  };
}

function closeLXHotelPickup() {
  return {
    type: _constant.CLOSE_LX_HOTEL_PICKUP
  };
}

function lxAcceptHotelPickup(id, isAccept) {
  return {
    types: [_constant.LX_ACCEPT_HOTEL_PICKUP, _constant.LX_ACCEPT_HOTEL_PICKUP_SUCCESS, _constant.LX_ACCEPT_HOTEL_PICKUP_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/lx-accept-hotel', { data: { isAccept: isAccept } });
    }
  };
}

function openLXStreetFoodPickup() {
  return {
    type: _constant.OPEN_LX_STREET_FOOD
  };
}

function closeLXStreetFoodPickup() {
  return {
    type: _constant.CLOSE_LX_STREET_FOOD
  };
}

function lxStreetFoodPickup(id, isAccept) {
  return {
    types: [_constant.LX_ACCEPT_STREET_FOOD, _constant.LX_ACCEPT_STREET_FOOD_SUCCESS, _constant.LX_ACCEPT_STREET_FOOD_FAIL],
    promise: function promise(client) {
      return client.post('/bookings/' + id + '/lx-accept-street-food', { data: { isAccept: isAccept } });
    }
  };
}

function lxOpenProposeNewDateModal() {
  return {
    type: _constant.LX_OPEN_PROPOSE_NEW_DATE_MODAL
  };
}

function lxCloseProposeNewDateModal() {
  return {
    type: _constant.LX_CLOSE_PROPOSE_NEW_DATE_MODAL
  };
}

function notifyWorryFreeBooking(bookingId) {
  return {
    types: [_constant.NOTIFY_WORRY_FREE_BOOKING, _constant.NOTIFY_WORRY_FREE_BOOKING_SUCCESS, _constant.NOTIFY_WORRY_FREE_BOOKING_FAIL],
    promise: function promise(client) {
      return client.post('/slack/worry-free-booking', { data: { bookingId: bookingId } });
    }
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/booking/actions.js
// module id = 78
// module chunks = 47